import "./Pricing.module.css";
import Header from "@/reusable_sections/Header";
import TabbedPricing from "./sections/TabbedPricing";
import ContactHero from "./sections/ContactHero";
import Policies from "./sections/Policies";
import Upgrades from "./sections/Upgrades";
import Footer from "@/reusable_sections/Footer";
export default function PricingPage() {
  return <div>
      <Header />
      <TabbedPricing />
      <Upgrades />
      <Policies />
      <ContactHero />
      <Footer />
    </div>;
}